import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import NavBar from './pages/navabar/navbar';
import Home from  './pages/home/home';
import Map from './pages/map/map';
import GeoJsonHandler from './pages/map/Geojsonhandler';
import ImageOverlay from './pages/map/imageoverlay';
import MapDraw from './pages/map/mapdraw';
import File from './pages/file/file';
import Edit from './pages/edit/edit';
import Output from './pages/output/output';
import Image from './pages/image/image';
import Settings from './pages/settings/settings';





function App() {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Home />}>
        <Route path="/navbar" element={<NavBar />} />
        <Route path="/map" element={<Map/>}/>
        <Route path="/geojson" element={<GeoJsonHandler/>}/>
        <Route path="/imageoverlay" element={<ImageOverlay/>}/>
        <Route path="/mapdraw" element={<MapDraw/>}/>
        <Route path="/file" element={<File/>}/>
        <Route path="/edit" element={<Edit/>}/>
        <Route path="/output" element={<Output/>}/>
        <Route path="/image" element={<Image/>}/>
        <Route path="/settings" element={<Settings/>}/>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
